import React, { PureComponent } from 'react';

import { withEventState } from 'src/ver2/pages/event/context';



import StatsGraphics from '../../../stats/components/graphics';
import { Checkbox } from 'antd';

// import { Link } from 'react-router-dom';
import moment from 'moment/min/moment-with-locales';
import 'moment/locale/ru';
import './style.css';

class EventCompetitorsStatsPlashka extends PureComponent {

    legendAll = 5;
    timer = null;

    state = {
        datas: {

        },
        loadedMainEvent: false,
        processOtherLoaded: false,

        eventsIds: {},
        showValues: true
    }

    timerTime = () => {
        const { client, eventsLoaded, Event } = this.props;
        const { processOtherLoaded, loadedMainEvent } = this.state;

        if (!processOtherLoaded && client.state.championships && loadedMainEvent && eventsLoaded) {
            this.eventsAsObject = client.state.eventsAsObject;
            this.setState({ processOtherLoaded: true });

            let EventsIdsForLoad = [];

            const EventsArray = Object.values(client.state.eventsAsObject).reverse();

            let locCompetition = null;
            locCompetition = client.state.championships[Event.ChampionshipId];
            if (locCompetition && locCompetition[0]) { locCompetition = locCompetition[0] } else locCompetition = null;

            if (locCompetition)
                for (let i = 0; i < EventsArray.length; i++) {
                    if (EventsIdsForLoad.length > 9) break;
                    const locEvent = EventsArray[i];
                    if (locEvent.Id !== Event.Id && locEvent.ChampionshipId) {
                        let competition = client.state.championships[locEvent.ChampionshipId];
                        if (competition && competition[0]) { competition = competition[0] } else competition = null;
                        if (competition) {
                            const { Region, Type, Finished } = competition;
                            if (Finished && Region === locCompetition.Region && Type === locCompetition.Type) {
                                // console.log('locEvent', locEvent);
                                EventsIdsForLoad.push(locEvent.Id);
                            }
                        }
                    }

                }

            if (EventsIdsForLoad.length) {
                for (let i = 0; i < EventsIdsForLoad.length; i++) {
                    const locId = EventsIdsForLoad[i];
                    this.loadCompetitionStat(client.state.eventsAsObject[locId], null, client.state.eventsAsObject[locId].ChampionshipId)
                }
            }

            if (EventsIdsForLoad.length) {
                const eventsIds = EventsIdsForLoad.reduce((memo, val) => { return { ...memo, [val]: false } }, {});
                this.setState({ eventsIds })
            }

            // // пока как заглушка 
            // if (Event.Id !== 441)
            //     this.loadCompetitionStat(client.state.eventsAsObject[441], null, client.state.eventsAsObject[441].ChampionshipId)

            clearTimeout(this.timer);
            delete this.timer;
        }
    }

    loadCompetitionStat = async (event, eventId, competitionId) => {
        const { client, Event } = this.props;
        const stats = await client.getStatistics('["partic_stat"]', null, null, null, null, null, null, null, null, competitionId);
        let isMainEvent;

        if (stats && stats.particStat && stats.particStat.length) {
            const dtFirst = stats.particStat[0].dt;

            const dtFirstMoment = moment(dtFirst, 'YYYY-MM-DD').locale('ru');

            const { Date, Id } = event;
            const dtEndMoment = moment(Date, 'DD.MM.YYYY').locale('ru');

            const diff = dtEndMoment.diff(dtFirstMoment, 'days');

            if (Event.Id === (event.Id || eventId)) {
                this.legendAll = diff;
            }
            const { legendAll } = this;

            const dayKoef = legendAll / diff; // 30 / 19

            let datas = [];

            for (let i = 0; i < legendAll; i++) {
                datas.push({ x: i, y: 0 });
            }

            for (let i = 0; i < stats.particStat.length; i++) {
                const { dt, count } = stats.particStat[i];
                const dateNow = moment(dt, 'YYYY-MM-DD').locale('ru');
                const diff = dateNow.diff(dtFirstMoment, 'days');
                const thisDayByAxe = Math.round(diff * dayKoef);
                if (thisDayByAxe < legendAll) {
                    datas[thisDayByAxe].y += count;
                } else {
                    datas[legendAll - 1].y += count;
                }
            }

            for (let i = 0; i < datas.length; i++) {
                if (i > 0) {
                    datas[i].y += datas[i - 1].y;
                }
            }

            if (event && event.Id && event.Id === Event.Id) {
                isMainEvent = true;
            }

            if (isMainEvent) {
                let splitThing
                for (let i = datas.length - 1; i >= 0; i--) {
                    if (i > 1) {
                        if (datas[i].y === datas[i - 2].y && (!splitThing || splitThing === datas[i].y)) {
                            datas = datas.slice(0, datas.length - 1);
                            splitThing = datas[i - 2].y;
                        }
                    }
                }
            }

            const newState = { datas: { ...this.state.datas, [Id || eventId]: datas } };
            if (isMainEvent) newState.loadedMainEvent = true;

            // const needed = moment(dtFirst, 'YYYY-MM-DD').locale('ru').format('DD.MM.YYYY');
            this.setState({ ...newState })
        }

    }

    componentDidMount = () => {
        this.timer = setInterval(this.timerTime, 50);
        const { Event } = this.props;
        if (Event && Event.ChampionshipId) {
            this.setState({ datas: { [Event.Id]: 'loading' } });
            this.loadCompetitionStat(Event, null, Event.ChampionshipId)
        }
    }

    componentDidUpdate = ({ Event, eventsLoaded }) => {
        if (!Event && this.props.Event && !this.state.datas[this.props.Event.Id]) {
            this.loadCompetitionStat(this.props.Event, null, this.props.Event.ChampionshipId)
        }
    }

    componentWillUnmount = () => {
        this.timer && clearInterval(this.timer);
        this.timer && delete this.timer;
    }

    get data() {
        const { client, eventsLoaded } = this.props;
        const { datas, eventsIds } = this.state;

        let data = [];
        const allEvents = Object.keys(datas);
        let mainEvent = null;

        for (let i = 0; i < allEvents.length; i++) {
            const key = allEvents[i];
            const val = datas[key];
            if (val === 'loading') { continue; }

            let title = key;
            if (eventsLoaded && client.state.eventsAsObject && client.state.eventsAsObject[key]) {
                title = client.state.eventsAsObject[key].Title;
            }

            if (this.mainEventId !== Number(key)) {
                if (eventsIds[key]) {
                    data.push(
                        { title, primaryNumber: i, dots: val }
                    )
                }
            }
            else mainEvent = { title, dots: val };

        }

        if (mainEvent) data = [mainEvent, ...data];

        if (data.length > 0) return data;
        return [{ title: '123', dots: [{ x: 0, y: 0 }] }]
    }

    get mainEventId() {
        const { Event } = this.props;
        return Event ? Event.Id : null;
    }

    render() {
        const legendsX = [];
        for (let i = 0; i < this.legendAll; i++) {
            legendsX.push({ title: i + 1 })
        }

        const data = {
            axes: {
                higherY: 0,
                yStep: 15,
                legendsX
            },
            data: this.data
        }

        const { upperStyle: { width, height }, innerId, isMobile } = this.props;
        const { showValues } = this.state;

        return <div style={{ width, height }} className='autoheight_plashka event_competitorsstats_plashka'>
            <div className='autoheight_plashka_inner' id={innerId}>
                <div className='event_competitorsstats_graph'>
                    <StatsGraphics showValues={showValues} size={'middle'} width={900} height={450} data={data} addFirstTitle={false} />
                </div>
                <div className='event_competitorsstats_events'>
                    <this.PanelSettings />
                    <this.PanelEvents />
                </div>
            </div>
        </div>
    }

    PanelSettings = () => {
        const { showValues } = this.state;
        return <div>
            УПРАВЛЕНИЯ
            <Checkbox checked={showValues} onChange={(e) => this.setState({ showValues: e.target.checked })}>Значения</Checkbox>
        </div>
    }

    PanelEvents = () => {
        const { eventsIds } = this.state;
        const { eventsLoaded, client } = this.props;

        const eventsIdsKeys = Object.keys(eventsIds).reverse();

        return <div className='event_competitorsstats_events_events'>
            МЕРОПРИЯТИЯ
            {eventsIdsKeys.map(key => {
                const title = (eventsLoaded && client.state.eventsAsObject && client.state.eventsAsObject[key] && client.state.eventsAsObject[key].Title) || key
                return <Checkbox key={key} checked={eventsIds[key]} onChange={(e) => this.setState({ eventsIds: { ...eventsIds, [key]: !eventsIds[key] } })}>{title}</Checkbox>
            })}
        </div>
    }

}

export default withEventState(`
        Event, 
        eventsLoaded,


        client,
        iamuser,
        isMobile
        
        `)(EventCompetitorsStatsPlashka)